module.exports = __webpack_public_path__ + "img/idc_datacenter_pic06.a42ef826.png";